import {
  Component,
  ChangeDetectionStrategy,
  Input, ChangeDetectorRef, ViewChild
} from '@angular/core';
import { IDeliveryOrder } from '../../core/interfaces/IDeliveryOrder';
import { AddEditModalGeneric } from '../../../../ui/generics';
import { AddEditOrderFormComponent } from '../add-edit-order-form/add-edit-order-form.component';
import { OrderTypes } from '../../core/enums';
import { OrderChangeLogModalComponent } from '../order-change-log-modal/order-change-log-modal.component';

@Component({
    selector: 'app-add-edit-order-modal',
    templateUrl: './add-edit-order-modal.component.html',
    styleUrls: ['./add-edit-order-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditOrderModalComponent extends AddEditModalGeneric<IDeliveryOrder, AddEditOrderFormComponent> {

  @Input() orderType = OrderTypes.MIXED;

  public readonly orderTypes = OrderTypes;

  @ViewChild('orderChangeLogModal') orderChangeLogModal: OrderChangeLogModalComponent;

  public headerStatus: string = null;

  constructor(
    protected cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  rebuildTitle(): void {
    if (this.isNew) {
      this.title = 'Neu erstellen';
      return;
    }
    const supplier = this.object?.supplier?.['name'] || this.object?.supplier?.['value'] || '';
    this.title = `Bestellung #${this.object.id}${supplier ? ' · ' + supplier : ''}`;
  }

  override showModal(object: null | IDeliveryOrder): void {
    this.headerStatus = object?.status ?? null;
    super.showModal(object);
  }

  handleCancel(): void {
    this.form?.requestClose(() => super.handleCancel());
  }

  showCreateFromArticles(prefill: IDeliveryOrder): void {
    this.showModal(prefill);
    this.isNew = true;
    this.rebuildTitle();
  }

  openChangeLog(event: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    if (this.object?.id) {
      this.orderChangeLogModal?.showModal(this.object);
    }
  }

  onOrderSynced(order: IDeliveryOrder): void {
    if (!order) {
      return;
    }
    this.headerStatus = order.status;
    this.cdr.markForCheck();
  }
}
